import { IPaymentCardParam, IPaymentTaxParam } from '@src/type/business/businessPayment'
import instance from '../axios'

export const BusinessPaymentApis = {
  getPaymentInfo: () => instance.get(`/v1/corporate/payment`),
  setPayment: (data: IPaymentCardParam | IPaymentTaxParam) => instance.post(`/v1/corporate/payment`, data),
  checkChagePayment: () => instance.get(`/v1/corporate/payment/claim`),
}
